<template>
    <div id="map-container" :style="{
        height: '425px',
        width: '100%',
        cursor: 'pointer'
    }"></div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix for default marker icons in Leaflet with Webpack
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

const DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

export default {
    name: "LeafletMap",

    props: {
        center: {
            type: Array,
            default: null,
        },

        coordinate: {
            type: Array,
            default: null,
        },
    },

    data() {
        return {
            map: null,
            marker: null,
            defaultCenter: [32.4279, 53.688],
            defaultZoom: 5,
        };
    },

    mounted() {
        this.initMap();

        this.initClickHandler();
        this.updateMarker();
    },

    beforeDestroy() {
        if (this.map) {
            this.map.remove();
        }

        this.marker = null;
    },

    watch: {
        // center: {
        //     immediate: true,
        //     handler(newCenter) {
        //         if (!this.map) return;

        //         if (newCenter && newCenter[0] != null) {
        //             this.map.setView(newCenter);
        //         } else {
        //             this.map.setView(this.defaultCenter, this.defaultZoom, {
        //                 animate: false,
        //             });
        //         }
        //     },
        // },

        coordinate: {
            immediate: true,
            handler() {
                this.updateMarker();
            },
        },
    },

    methods: {
        initMap() {
            this.map = L.map("map-container");

            L.tileLayer(
                "http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
                {
                    maxZoom: 22,
                    subdomains: ["mt0", "mt1", "mt2", "mt3"],
                    attribution: "Google Maps",
                }
            ).addTo(this.map);

            if (this.center && this.center[0] != null) {
                this.map.setView(this.center, 12);
            } else {
                this.map.setView(this.defaultCenter, this.defaultZoom, {
                    animate: false,
                });
            }
        },

        initClickHandler() {
            this.map.on("click", (e) => {
                const clickedLatLng = [e.latlng.lat, e.latlng.lng];

                this.$emit("mapClick", clickedLatLng);
            });
        },

        updateMarker() {
            if (!this.map || !this.coordinate) return;

            if (this.marker) {
                this.marker.setLatLng(this.coordinate);
            } else {
                this.marker = L.marker(this.coordinate).addTo(this.map);
            }
        },
        invalidateMapSize() {
            if (this.map) {
                this.map.invalidateSize();
            }
        }
    },
};
</script>

<style scoped>
#map-container {
    z-index: 1;
}
</style>